import { Component } from 'react';

type PropsT = {
  telephonyGetQueryNumbers: (payload: any) => Promise<any>;
};

type StateT = {
  value: string;
};

export default class PhoneNumbersCustomInput extends Component<PropsT, StateT> {
  constructor(props: PropsT) {
    super(props);
    this.state = {
      value: '',
    };
  }

  onChange = (e: any) => {
    this.setState({ value: e.target.value });
    this.props.telephonyGetQueryNumbers({
      query: {
        search: e.target.value,
      },
    });
  };

  render() {
    return (
      <li className="phone-number-field-holder">
        <div className="form-group nolabel">
          <div className="input-group">
            <input
              type="text"
              placeholder="Type a number to filter..."
              onChange={this.onChange}
              value={this.state.value}
              className="form-control"
            />
          </div>
        </div>
      </li>
    );
  }
}
